// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393501720210 ",
  numero_telefono: "tel:+3908118895802",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',

  */

  urlWeb: 'https://discentya.accademiauge.cloud/',
  urlMaterialeDidattico: 'https://discentya.accademiauge.cloud/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.accademiauge.cloud/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.accademiauge.cloud/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.accademiauge.cloud/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.accademiauge.cloud/api/',

  urlStampa: 'https://discentya.accademiauge.cloud/stampe/',

  urlAttestati: 'https://discentya.accademiauge.cloud/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.accademiauge.cloud/pages/certificate/',
  urlImagePartners: 'https://discentya.accademiauge.cloud/assets/media/partners/',
  urlImageMedia: 'https://discentya.accademiauge.cloud/assets/media/',
};

